module.exports = __webpack_public_path__ + "img/Me2021v4.ee843c1b.jpg";